module.exports = __webpack_public_path__ + "img/1507455402.c96f5c83.jpg";